import Request from '../Request.utils'
export interface IGetApprovedBuyingListRequestQuery {
  locationExternalId: string | '' | null;
  offset?: number;
  search?: string | '' | null;
}
export interface IListShopifyOrderRequestQuery {
  details?: boolean;
  endDate?: string;
  hasDeliveryStatus?: 'false' | 'true' | '1' | '0';
  isBackOrder?: boolean;
  limit?: number;
  liveDeliveryOnly?: '' | 'true' | 'false' | '1' | '0';
  locationExternalId?: string;
  offset?: number;
  orderBy?: 'createdAt' | 'updatedAt';
  search?: string;
  startDate?: string;
  status?: string;
}
export interface IShopifyOrderRequestQuery {
  id: string;
}
export interface IRejectShopifyOrderIssueRequestBody {
  attachFiles?: string[];
  description?: string;
  orderId?: string;
  orderType?: string;
  type?: string;
}
export interface IGetBudgetCategoryRequestParams {
  locationId: string;
}
export interface IListDashboardSnapshotsRequestQuery {
  endDate?: string;
  limit?: number;
  offset?: number;
  orderBy?: 'snapshotDate' | 'createdAt';
  startDate?: string;
}
export interface ISubmitBackorderActionRequestBody {
  action: 'wait' | 'speak' | 'cancel';
  orderId: string;
}
export interface IUpdateOrderDataRequestBody {
  data: object;
  orderId: string;
}
export interface IAddOrderNoteRequestBody {
  action: 'add' | 'update' | 'delete';
  noteContent?: string;
  noteId?: string;
  orderId: string;
}
export interface IIsBackOrderRequestBody {
  sorId: string;
}
export interface ISyncCatalogsForLocationRequestBody {
  locationExternalId?: string;
  locationId?: string;
}
export interface ISyncPriceListCatalogRequestBody {
  priceListCode: string;
}
export interface ISyncPriceListCatalogStatusRequestQuery {
  jobId: string;
}
export interface ISyncApprovedBuyingListByLocationRequestBody {
  dryRun?: boolean;
  locationExternalId?: string;
  locationId?: string;
}
export interface ISyncApprovedBuyingListByCompanyRequestBody {
  companyId?: string;
  dryRun?: boolean;
  externalId?: string;
}
export interface ISyncApprovedBuyingListByLocationStatusRequestQuery {
  jobId: string;
}
export interface IApproveDraftOrderRequestBody {
  amendmentReason?: string;
  amendments?: {
    lineItemId: string;
    quantity?: number;
    removed?: boolean;
  }[];
  approveOverBudget?: boolean;
  draftOrderId: string;
}
export interface IGetDraftOrderRequestQuery {
  draftOrderId: string;
}
export interface ISaveDraftOrderAmendmentRequestBody {
  amendmentReason?: string;
  amendments?: {
    lineItemId: string;
    quantity?: number;
    removed?: boolean;
  }[];
  draftOrderId: string;
}
export interface IResetDraftOrderAmendmentRequestBody {
  draftOrderId: string;
}
export interface IListDraftOrdersRequestQuery {
  endDate?: string;
  limit?: number;
  locationExternalId?: string;
  offset?: number;
  search?: string;
  startDate?: string;
  status?: 'pending' | 'approved' | 'denied';
}
export interface IListLocationsRequestQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}
export interface ICancelDraftOrderRequestBody {
  draftOrderId: string;
}
export interface ISyncAblMasterFromShopifyByCompanyRequestBody {
  all?: boolean;
  companyId?: string | '' | null;
  shopifyDelayMs?: number;
  shopifyMaxRetries?: number;
}
export interface ISyncBCCompanyLocationsRequestBody {
  companyExternalId: string;
}
export interface ISyncBCCompanyLocationsStatusRequestQuery {
  jobId: string;
}
export interface ISyncCompanyLocationAblFromShopifyRequestBody {
  all?: boolean;
  companyId?: string | '' | null;
  locationId?: string | '' | null;
}


class ShopifyAPI {
  getMyLocations = async () => {
    const res = await Request.call('/api/shopify/my-locations', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getApprovedBuyingList = async (query: IGetApprovedBuyingListRequestQuery) => {
    const res = await Request.call('/api/shopify/approved-buying-list', 'GET', undefined, query, undefined, );
    return res;
  }
  listShopifyOrder = async (query: IListShopifyOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/list-shopify-order', 'GET', undefined, query, undefined, );
    return res;
  }
  getOrderStats = async () => {
    const res = await Request.call('/api/shopify/order-stats', 'GET', undefined, undefined, undefined, );
    return res;
  }
  shopifyOrder = async (query: IShopifyOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/get-shopify-order', 'GET', undefined, query, undefined, );
    return res;
  }
  rejectShopifyOrderIssue = async (body: IRejectShopifyOrderIssueRequestBody) => {
    const res = await Request.call('/api/shopify/create-order-issue', 'POST', undefined, undefined, body, );
    return res;
  }
  getBudgetCategory = async (params: IGetBudgetCategoryRequestParams) => {
    const res = await Request.call('/api/shopify/location/:locationId/budget-category', 'GET', params, undefined, undefined, );
    return res;
  }
  listDashboardSnapshots = async (query: IListDashboardSnapshotsRequestQuery) => {
    const res = await Request.call('/api/shopify/list-dashboard-snapshots', 'GET', undefined, query, undefined, );
    return res;
  }
  getDashboardMetrics = async () => {
    const res = await Request.call('/api/shopify/get-dashboard-metrics', 'GET', undefined, undefined, undefined, );
    return res;
  }
  submitBackorderAction = async (body: ISubmitBackorderActionRequestBody) => {
    const res = await Request.call('/api/shopify/submit-backorder-action', 'POST', undefined, undefined, body, );
    return res;
  }
  updateOrderData = async (body: IUpdateOrderDataRequestBody) => {
    const res = await Request.call('/api/shopify/update-order-data', 'POST', undefined, undefined, body, );
    return res;
  }
  addOrderNote = async (body: IAddOrderNoteRequestBody) => {
    const res = await Request.call('/api/shopify/manage-order-notes', 'POST', undefined, undefined, body, );
    return res;
  }
  isBackOrder = async (body: IIsBackOrderRequestBody) => {
    const res = await Request.call('/api/shopify/is-back-order', 'POST', undefined, undefined, body, );
    return res;
  }
  syncCatalogsForLocation = async (body: ISyncCatalogsForLocationRequestBody) => {
    const res = await Request.call('/api/shopify/sync-catalogs-for-location', 'POST', undefined, undefined, body, );
    return res;
  }
  syncPriceListCatalog = async (body: ISyncPriceListCatalogRequestBody) => {
    const res = await Request.call('/api/shopify/sync-price-list-catalog', 'POST', undefined, undefined, body, );
    return res;
  }
  syncPriceListCatalogStatus = async (query: ISyncPriceListCatalogStatusRequestQuery) => {
    const res = await Request.call('/api/shopify/sync-price-list-catalog/status', 'GET', undefined, query, undefined, );
    return res;
  }
  syncApprovedBuyingListByLocation = async (body: ISyncApprovedBuyingListByLocationRequestBody) => {
    const res = await Request.call('/api/shopify/sync-approved-buying-list-by-location', 'POST', undefined, undefined, body, );
    return res;
  }
  syncApprovedBuyingListByCompany = async (body: ISyncApprovedBuyingListByCompanyRequestBody) => {
    const res = await Request.call('/api/shopify/sync-approved-buying-list-by-company', 'POST', undefined, undefined, body, );
    return res;
  }
  syncApprovedBuyingListByLocationStatus = async (query: ISyncApprovedBuyingListByLocationStatusRequestQuery) => {
    const res = await Request.call('/api/shopify/sync-approved-buying-list-by-location/status', 'GET', undefined, query, undefined, );
    return res;
  }
  approveDraftOrder = async (body: IApproveDraftOrderRequestBody) => {
    const res = await Request.call('/api/shopify/approve-draft-order', 'POST', undefined, undefined, body, );
    return res;
  }
  getDraftOrder = async (query: IGetDraftOrderRequestQuery) => {
    const res = await Request.call('/api/shopify/get-draft-order', 'GET', undefined, query, undefined, );
    return res;
  }
  saveDraftOrderAmendment = async (body: ISaveDraftOrderAmendmentRequestBody) => {
    const res = await Request.call('/api/shopify/save-draft-order-amendment', 'POST', undefined, undefined, body, );
    return res;
  }
  resetDraftOrderAmendment = async (body: IResetDraftOrderAmendmentRequestBody) => {
    const res = await Request.call('/api/shopify/reset-draft-order-amendment', 'POST', undefined, undefined, body, );
    return res;
  }
  listDraftOrders = async (query: IListDraftOrdersRequestQuery) => {
    const res = await Request.call('/api/shopify/list-draft-orders', 'GET', undefined, query, undefined, );
    return res;
  }
  listLocations = async (query: IListLocationsRequestQuery) => {
    const res = await Request.call('/api/shopify/list-locations', 'GET', undefined, query, undefined, );
    return res;
  }
  cancelDraftOrder = async (body: ICancelDraftOrderRequestBody) => {
    const res = await Request.call('/api/shopify/cancel-draft-order', 'POST', undefined, undefined, body, );
    return res;
  }
  syncAblMasterFromShopifyByCompany = async (body: ISyncAblMasterFromShopifyByCompanyRequestBody) => {
    const res = await Request.call('/api/shopify/sync-abl-master-from-shopify/by-company', 'POST', undefined, undefined, body, );
    return res;
  }
  syncBCCompanyLocations = async (body: ISyncBCCompanyLocationsRequestBody) => {
    const res = await Request.call('/api/shopify/sync-bc-company-locations', 'POST', undefined, undefined, body, );
    return res;
  }
  syncBCCompanyLocationsStatus = async (query: ISyncBCCompanyLocationsStatusRequestQuery) => {
    const res = await Request.call('/api/shopify/sync-bc-company-locations/status', 'GET', undefined, query, undefined, );
    return res;
  }
  syncCompanyLocationAblFromShopify = async (body: ISyncCompanyLocationAblFromShopifyRequestBody) => {
    const res = await Request.call('/api/shopify/sync-company-location-abl-from-shopify', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new ShopifyAPI()